import { Box } from "@mui/material";
import { BarChart } from "@mui/x-charts";
import { CHART_COLORS } from "../../config/constants/common";
import BarChartLoader from "../../common-ui/loaders/BarChartLoader";

export type ChartData = {
  yData: number[];
  xLabels: string[];
};

interface Props {
  data: ChartData;
  loading: boolean;
  height?:number
}

export const DmmsBarChart = ({ data, loading ,height=300}: Props) => {
  return (
    <Box >
      {loading ? (
        <BarChartLoader height={height} />
      ) : (
        <BarChart
          colors={CHART_COLORS}
          xAxis={[{ data: data.xLabels, scaleType: "band" }]}
          series={[{ data: data.yData }]}
          height={height}
        />
      )}
    </Box>
  );
};
